import React, { useEffect, useState } from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const hasToken = !!localStorage.getItem("authToken");

  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    setDarkMode(savedMode === "true");
  }, []);

  return (
    <section className={`hero-wrapper ${darkMode ? "dark-mode" : ""}`}>
      {/* 1. الخلفية */}
      <div className="hero-background"></div>

      {/* 2. العناصر الطائرة في الشاشة كلها */}
      <div className="flying-elements">
        <span className="book">📚</span>
        <span className="letter">A</span>
        <span className="letter">B</span>
        <span className="letter">C</span>
        <span className="book">📖</span>
        <span className="book">🪶</span>
      </div>

      {/* 3. حاوية المحتوى (Flexbox) */}
      <div className="container hero-container">
        
        {/* الجزء الأيمن: النصوص والأزرار */}
        <div className="hero-text-content">
          <Heading
            title={
              <>
                <span className="text-highlight">Edu Masr</span>
                <br />
                اكتشف عالم المعرفه
              </>
            }
          />
          <p className="hero-desc">
            💪 خليك جاهز للنجاح من أول درس شرح واضح، تدريبات قوية، ونتائج مبهرة
          </p>
          <div className="hero-buttons">

{!hasToken 
? 
(
  <button className="primary-btn" onClick={() => navigate("/Login")}>
    انضم الآن <i className="fa fa-long-arrow-alt-left"></i>
  </button>
  ) 
  : 
  (
    <button onClick={() => navigate("/Teachers")} className="btn login">
      مدرسيني
    </button>
    
  )}
</div>
        </div>

        {/* الجزء الأيسر: الصورة والإطار الزجاجي */}
        <div className="hero-image-content">
          <div className="img-frame">
            <div className="fly-behind">
              <span className="item pen">✏️</span>
              <span className="item book">📘</span>
              <span className="item pencil">🖋️</span>
              <span className="item paper">📄</span>
            </div>
            <img
              src={darkMode ? "/images/person1.png" : "/images/backgroud2s.png"}
              className="imgt"
              alt="Edu Masr Hero"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;